<ng-container *transloco="let t">
  <div
    class="w-full bg-white p-sm sm:pb-0 sm:pl-2xl sm:pr-xl sm:pt-sm"
    style="
      box-shadow:
        0px 5px 5px 0px rgba(0, 0, 0, 0.1),
        0px 6px 24px -2px rgba(0, 0, 0, 0.22);
    "
  >
    <div class="flex flex-row justify-between 2xl:h-layout">
      <div class="order-2 flex flex-col xl:w-full xl:max-w-[400px]">
        <div class="row flex h-[2.75rem] items-center">
          <bgo-share-button
            [buttonText]="t('newStickyFooter.share')"
            [modalTitle]="shareTitle"
            [modalPlot]="sharePlot"
          ></bgo-share-button>
        </div>
      </div>
      <div class="order-3 hidden xl:flex">
        <ng-content></ng-content>
      </div>
      <div class="order-4 xl:w-full xl:max-w-[450px]">
        <div class="flex flex-row justify-end gap-md">
          <div class="flex justify-between xl:space-x-sm">
            @if (secondaryCallToAction) {
              <cft-call-to-action
                callToActionStyle="button-sm"
                class="!hidden xl:!flex"
                buttonStyle="secondary"
                [callToAction]="secondaryCallToAction"
              />
            }
            <cft-call-to-action
              callToActionStyle="button-sm"
              buttonStyle="hero"
              [callToAction]="getMainCallToAction()"
            />
          </div>
        </div>
        <div class="my-xs hidden text-right text-xs text-president-400 sm:block">
          <p>
            {{ t('newStickyFooter.tagline') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
